import React from 'react';

const educationComponent = props => {
  return (
      <div className="section-wrapper z-depth-1">
        <div className="section-icon col s12 m12 l2">
          <i className="fa fa-graduation-cap"/>
        </div>
        <div className="custom-content col s12 m12 l10 wow fadeIn a1" data-wow-delay="0.1s">
          <h2>Education </h2>

          <div className="custom-content-wrapper wow fadeIn a2" data-wow-delay="0.2s">
            <h3>Decision & System Sciences <span>@Saint Joseph's University - Erivan K. Haub School of Business</span>
            </h3>
            <span>2002 - 2016 </span>
            <p>Activities and Societies: lpha Iota Delta, BITS (Business Info. & Technology Society) </p>
          </div>
        </div>
      </div>
  )
};

export default educationComponent;